// extracted by mini-css-extract-plugin
export default {"white_text":"ConfirmModal_white_text__i3ZVo"};